interface FeedbackData {
  type: 'bug' | 'feature' | 'feedback';
  subject: string;
  description: string;
  userEmail: string;
  userName?: string;
  schoolName?: string;
  browserInfo?: string;
}

interface FeedbackResponse {
  success: boolean;
  messageId?: string;
  message?: string;
  error?: string;
}

/**
 * Send feedback to the backend Cloud Function
 * @param feedbackData The feedback data to send
 * @returns Promise with the result of the feedback submission
 */
export async function sendFeedback(feedbackData: FeedbackData): Promise<FeedbackResponse> {
  try {
    const response = await fetch(
      'https://us-central1-schoolsync-bfccc.cloudfunctions.net/sendFeedbackEmail',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(feedbackData),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      console.error('Feedback API error:', data);
      return {
        success: false,
        error: data.error || 'Failed to send feedback',
      };
    }

    return {
      success: true,
      messageId: data.messageId,
      message: data.message,
    };
  } catch (error) {
    console.error('Error sending feedback:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Network error occurred',
    };
  }
}